"use client";

import styled from "styled-components";
import Icon from "@/components/icon";

export const InputGroup = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const IconComponent = styled(Icon)`
  position: absolute;
  left: 15px;
  top: 50%;
  margin-top: -9px;

  svg {
    transition: 0.3s easy-out;
    stroke: var(--borderGraySearch);
    width: 18px;
    height: 18px;
  }
`;

export const InputComponent = styled.input`
  border: 1px solid var(--border);
  height: 36px;
  max-width: 350px;
  border-radius: 7px;
  box-shadow: none !important;
  padding-left: 40px;
  padding-right: 15px;
  background: transparent;
  font-family: "Roboto Light";
  font-size: 15px;
  color: var(--textLight);
  height: 42px;
  width: 100%;

  &:focus {
    border-color: var(--primarySystem);
    outline: none;
  }

  &::placeholder {
    color: var(--placeholderColor);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  display: block;
  color: var(--red);
  margin-top: 4px;
`;
